import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AppFilter } from '@app/shared/models';
import { CustomerTenderService } from '../../services/customer-tenders.service';
import { DocumentService } from '../../services/document.service';
interface IPrintSlipModalContext {
  title?: string;
  question: any;
}
@Component({
  selector: 'app-print-slip-modal',
  templateUrl: './print-slip-modal.component.html',
  styleUrls: ['./print-slip-modal.component.scss'],
})
export class PrintSlipModalComponent implements OnInit, OnDestroy {
  verificationMeans = ['Active', 'Rejected'];
  selectionMethod = ['Active', 'Rejected'];
  procurementType = ['Active', 'Rejected'];
  procurementitemsParams: AppFilter;
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pendingArr = [];
  lotForm: FormGroup;
  clicked = false;
  eventDetail;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IPrintSlipModalContext, void, void>,
    private customerTenderService: CustomerTenderService,
    private docService: DocumentService
  ) {
    this.lotForm = fb.group({
      afirstName: ['', Validators.required],
      alastName: ['', Validators.required],
      aphoneNumber: ['', Validators.required],
      adesignation: ['', Validators.required],

      bfirstName: ['', Validators.required],
      blastName: ['', Validators.required],
      bphoneNumber: ['', Validators.required],
      bdesignation: ['', Validators.required],
    });
    this.procurementitemsParams = new AppFilter({
      page: 1,
      rows: 1000,
    });
    this.eventDetail = modal.context.question;
  }

  print() {
    if (this.lotForm.valid) {
      console.log(this.eventDetail, 'this.eventDetail');
      let bidSubmissionAttendee = JSON.stringify({
        firstName: this.lotForm.value.afirstName,
        lastName: this.lotForm.value.alastName,
        phone: this.lotForm.value.aphoneNumber,
        designation: this.lotForm.value.adesignation,
      });
      let bidOpeningAttendee = JSON.stringify({
        firstName: this.lotForm.value.bfirstName,
        lastName: this.lotForm.value.blastName,
        phone: this.lotForm.value.bphoneNumber,
        designation: this.lotForm.value.bdesignation,
      });

      let body = {
        procTenderEventDetailsId: this.eventDetail.procTenderEventDetailsId,
        lotId: this.eventDetail.lotId,
        bidSubmissionAttendee,
        bidOpeningAttendee,
        biddingStageId: this.eventDetail.biddingStageId,
        bidderId: JSON.parse(localStorage.getItem('BIDDER_ID')),
      };

      this.callStarted();
      this.customerTenderService
        .printSubmissionSlip({
          body,
        })
        .subscribe(
          (res) => {
            this.success = 'Successful';
            this.downloadActualDocumentPdf(res.documentId);
            this.callCompleted();
            setTimeout(() => {
              this.modal.approve();
            }, 1000);
          },
          (error) => {
            this.error = error.error ? error.error : error;
            this.callCompleted();
          }
        );
    } else {
      this.error = 'Please make sure you filled all required fields';
    }
  }

  callStarted() {
    this.pendingArr.push(true);
  }

  callCompleted() {
    this.pendingArr.pop();
  }

  downloadActualDocumentPdf(item) {
    this.callStarted();
    this.docService
      .downloadDocumentPdf({
        documentId: item,
      })
      .subscribe(
        (response) => {
          this.callCompleted();
          var blob = new Blob([response.body], {
            type: response.body.type,
          });
          var url = window.URL.createObjectURL(blob);
          var anchor = document.createElement('a');
          anchor.download = 'document';
          anchor.href = url;
          anchor.click();
          this.success = 'Document downloaded Successfully';
          setTimeout(() => {
            this.modal.approve();
          }, 2000);
        },
        (error) => {
          this.callCompleted();
          this.error = error.error;
        }
      );
  }

  isFieldValid(field: string) {
    return (
      (!this.lotForm.get(field).valid && this.lotForm.get(field).touched) ||
      (this.lotForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      pending: field,
    };
  }
  save() {}
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    this.document.body.classList.add('panel');
  }
  // s
  ngOnDestroy(): void {
    this.document.body.classList.remove('panel');
  }
}

export class PrintSlipModal extends ComponentModalConfig<
  IPrintSlipModalContext,
  void,
  void
> {
  constructor(title: string, question: any, size: ModalSize = ModalSize.Small) {
    super(PrintSlipModalComponent, { title, question });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
